import { useLocation } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import type { Theme } from '@mui/material/styles';
import { ROUTES } from '@constants/routes';
import { useAnyOverlayOpen } from '@store/overlayStore';

const HIDDEN_ROUTES: readonly string[] = [ROUTES.BUSINESS, ROUTES.DONE];

export const useContactFabVisibility = (): boolean => {
  const { pathname } = useLocation();
  const isMobileOrTablet = useMediaQuery((t: Theme) => t.breakpoints.down('lg'));
  const anyOverlayOpen = useAnyOverlayOpen();

  const routeVisible = !HIDDEN_ROUTES.includes(pathname);
  return routeVisible && !(anyOverlayOpen && isMobileOrTablet);
};
